import { apiGet } from '../../api'

export const get_all_recruits = group_id => {
  return apiGet({
    endpoint: `recruitment/get_all_recruits${group_id ? `?group_id=${group_id}` : ''}`
  })
}
